import { createElement, Fragment } from "react"
import { createRoot } from "react-dom/client"

import { D2cPageLoadRecovery } from "../d2c-lead-flow/D2cPageLoadRecovery.jsx"

import { HelocPortalToastHost } from "../lib/helocPortalToast.jsx"

/**
 * Lazy loaders for every Inertia page. Co-located *.test.jsx files are excluded
 * at build time (negated glob) so production bundles never pull in vitest,
 * jsdom helpers, testing-library, or other test-only deps.
 */
export const pageModuleLoaders = import.meta.glob([
  "../pages/**/*.jsx",
  "!../pages/**/*.test.jsx",
])

export function resolveInertiaPage(name) {
  const loadPage = pageModuleLoaders[`../pages/${name}.jsx`]
  if (!loadPage) {
    console.error(`Missing Inertia page component: '${name}.jsx'`)
    return undefined
  }

  if (name !== "D2cLeadFlow") return loadPage()
  const recovery = { default: D2cPageLoadRecovery }
  try {
    const page = loadPage()
    return page instanceof Promise ? page.catch(() => recovery) : page
  } catch {
    return recovery
  }
}

export function setupInertia({ el, App, props }) {
  if (el) {
    createRoot(el).render(
      createElement(Fragment, null, createElement(HelocPortalToastHost), createElement(App, props)),
    )
  } else {
    console.error(
      "Missing root element.\n\n" +
        "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
        'Consider moving <%= vite_javascript_tag "inertia" %> to the Inertia-specific layout instead.',
    )
  }
}

export const inertiaAppOptions = {
  resolve: resolveInertiaPage,
  setup: setupInertia,
}
